import { Icon, Text } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { StatsMenuActionItem } from '../../types'

export const StatsMenuActions = ({
  onSelect,
  actions,
}: {
  onSelect: (action: StatsMenuActionItem) => void
  actions: StatsMenuActionItem[]
}) => {
  const { colors } = useTheme()

  return (
    <div>
      <Text
        className={css`
          padding: 0 12px;
        `}
        type="label"
        sizing="L"
        color={colors.uiPewterGrey}
      >
        Manage your Reading Stats
      </Text>
      <ul>
        {actions.map((a) => {
          if (a.type === 'deep_link' && !a.link?.length) return null

          return (
            <li
              role="button"
              key={a.id}
              className={css`
                display: flex;
                align-items: center;
                gap: 12px;
                padding: 0 20px 0 12px;
                height: 46px;
                cursor: pointer;
              `}
              onClick={() => {
                onSelect(a)
                a.onClick?.()
              }}
            >
              <Icon
                className={css`
                  width: 21px;
                `}
                type={a.icon}
                fill={colors.uiWhite}
              />
              <Text type="body" sizing="M" color={colors.uiWhite}>
                {a.text}
              </Text>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
